import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// Typography
import { Body2 } from '../../themes/typography';

export default function MuiSelectOptions({
    label,
    options,
    value,
    onChange,
    disabled,
    error,
    helperText,
    multiple,
    id,
    fullWidth
}) {
    return (
        <FormControl
            error={error}
            fullWidth={fullWidth}
            // sx={{ gap: '3px' }}
        >
            <InputLabel>
                <Body2>{label}</Body2>
            </InputLabel>
            <Select
                variant="outlined"
                id={id}
                value={value}
                label={label}
                onChange={onChange}
                disabled={disabled}
                multiple={multiple}
                sx={{
                    color: '#f5f5f5 !important',
                    borderRadius: '15px',
                    // minWidth: '250px',
                    // minWidth: '230px',
                    minWidth: '265px',
                    maxWidth: '100%',
                    fontFamily: 'Nunito, sans-serif !important',
                    '& .MuiSelect-iconOutlined': {
                        // arrow
                        color: '#f5f5f5'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#f5f5f5',
                        '&:hover fieldset': {
                            borderColor: '#F8A21E !important'
                        },
                        '&.Mui-focused fieldset': {
                            border: '1px solid #F8A21E'
                        }
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#F8A21E !important'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#F8A21E !important'
                    }
                }}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText
                sx={{
                    '&.MuiFormHelperText-root': {
                        color: '#f5f5f5',
                        margin: '6px 0px 0px 3px',
                        fontFamily: 'Nunito, sans-serif',
                        fontSize: '0.875rem',
                        lineHeight: 'none',
                        letterSpacing: '0px',
                        '&.Mui-error': {
                            color: '#f44336'
                        }
                    }
                }}
            >
                {helperText}
            </FormHelperText>
        </FormControl>
    );
}

// Default Props
MuiSelectOptions.defaultProps = {
    label: 'Age',
    options: [
        { value: 10, label: 'Ten' },
        { value: 20, label: 'Twenty' },
        { value: 30, label: 'Thirty' }
    ],
    onChange: (event) => console.log('Selected Age: ', event.target.value),
    disabled: false,
    error: false,
    helperText: '',
    fullWidth: false
};

// Open Options popup after the select input field instead of open on whole page by giving position relative to the select input field and absolute to the options popup.
